import { call, put, takeLatest } from 'redux-saga/effects'
import { getMoneygramSettings } from 'portal-modules/payments/api/api'
import { LOGOUT } from 'portal-modules/auth/redux/modules/user'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'

// action types
export const REQUEST_MONEYGRAM_SETTINGS =
  'rp/moneygram/REQUEST_MONEYGRAM_SETTINGS'
export const RECEIVE_MONEYGRAM_SETTINGS =
  'rp/moneygram/RECEIVE_MONEYGRAM_SETTINGS'

// action creators
export const requestMoneygramSettings = () => ({
  type: REQUEST_MONEYGRAM_SETTINGS,
})

export const receiveMoneygramSettings = payload => ({
  type: RECEIVE_MONEYGRAM_SETTINGS,
  payload,
})

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case RECEIVE_MONEYGRAM_SETTINGS:
      return { ...state, ...payload }
    case LOGOUT:
      return {}
    default:
      return state
  }
}

function* fetchMoneygramSettings() {
  const moneygramSettings = yield call(getMoneygramSettings)
  yield put(receiveMoneygramSettings(moneygramSettings))
}

function* watchRequestMoneygramSettings() {
  yield takeLatest(
    REQUEST_MONEYGRAM_SETTINGS,
    createRequestSaga(fetchMoneygramSettings, {
      key: 'global',
    }),
  )
}

export const sagas = [watchRequestMoneygramSettings]
